import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { history } from '../../../../store';
import BrandCarouselItem from './brand-carousel-item';
import CarouselRender from './carousel-render';

import './brand-carousel.css';
import './style.css';

class BrandCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isScrolled: false,
      data: []
    };
  }

  renderBrandBanner = () => {
    const { links, attributes } = this.props.brandsHomepageBanner[0];

    return (
      <div className="brand-carousel-banner-container">
        <img src={links.banner} alt={attributes.name} className="brand-carousel-banner-image" />
        <div className="brand-carousel-content-container">
          <div className="brand-carousel-text-container">
            {attributes['banner-title'] && (
              <h3
                id="brand-carousel-title"
                style={{
                  color: attributes['banner-text-colour']
                }}
              >
                {attributes['banner-title'] || ''}
              </h3>
            )}
            <p
              id="brand-carousel-subtitle"
              style={{
                color: attributes['banner-text-colour']
              }}
            >
              {attributes['banner-text'] || ''}
            </p>
            {attributes['banner-button-text'] && (
              <Button
                id="brand-carousel-button"
                className='red-btn'
                onClick={() => {
                  if (attributes['banner-button-url'].match(/^https?:.*/i)) {
                    window.open(attributes['banner-button-url'], '_blank');
                  } else {
                    history.push(attributes['banner-button-url']);
                  }
                }}
              >
                {attributes['banner-button-text']}
              </Button>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderItems = () => {
    const { brands } = this.props;
    const { isScrolled } = this.state;

    this.setState({
      data: brands.map((brand, index) => (
        <BrandCarouselItem
          key={index}
          image={brand.links.photo}
          id={brand.id}
          name={brand.attributes.name}
          isScrolled={isScrolled}
        />
      ))
    });
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.brands !== this.props.brands &&
      Array.isArray(this.props.brands) &&
      !!this.props.brands.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  handleOnClick = () => {
    const { isScrolled } = this.state;

    this.setState({ isScrolled: !isScrolled }, () => {
      this.renderItems();
    });
  }

  render() {
    const { loading, brandsHomepageBanner } = this.props;
    const { data } = this.state;

    return (
      <div className="brand-carousel-container">
        {!!data.length && (
          <div className="user-inner-container">
            <h2>Brands</h2>
          </div>
        )}
        {!!brandsHomepageBanner.length && this.renderBrandBanner()}
        <CarouselRender loading={loading} data={data} onClick={this.handleOnClick} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.brandsUser.fetching,
  brands: state.brandsUser.brands,
  brandsHomepageBanner: state.brandsUser.brands.filter(brand =>
    brand.attributes['homepage-banner'])
});

export default connect(mapStateToProps)(BrandCarousel);



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/brand-carousel.jsx